import React, { Fragment, useEffect, useState } from "react";
import Breadcrumbs from '../../../components/Common/Breadcrumb';

import { Button } from '@shadcn/components/ui/button'

import * as moment from 'moment-timezone';
import useQuery from "../../../helpers/JIFI/useQuery";
import {backendUrl} from '../../../helpers/consts.js'
import superagent from 'superagent'
import Select from '@shadcn/components/ui/react-select';
import { Col } from "@shadcn/components/ui/col";
import { Row } from "@shadcn/components/ui/row";
import { TooltipContent, TooltipProvider, TooltipTrigger,Tooltip } from "@shadcn/components/ui/tooltip";
var XLSX = require("xlsx");

const localLocations = {
  'AU': ['HQ2', 'QV Store', 'EWE', 'EWE - Sydney', 'Galeries Sydney', '80 Collins', 'CHDRETAIL', 'Bondi', 'Canberra', 'Chatswood'],
  'US': ['USA - Dallas', 'UNIS'],
  'UK': ['Airbox UK']
}

var formatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
  maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
});

function safeNum(v) {
  const n = Number(v);
  return Number.isFinite(n) ? n : 0;
}

function formatCurrencyUsd(v) {
  return formatter.format(safeNum(v));
}

/** Avoid Infinity/NaN when sales estimate is 0 */
function safeMonthsCoverDisplay(onHand, salesEstimate) {
  const o = safeNum(onHand);
  const s = safeNum(salesEstimate);
  if (s === 0) return '0.0';
  const r = o / s;
  if (!Number.isFinite(r) || r < 0) return '0.0';
  return Math.min(1e6, r).toFixed(1);
}

function computeCasesPerRev(previousRevs, previousBreakdowns) {
  const ratios = previousRevs.map((val, key) => {
    const rev = safeNum(val);
    const b = safeNum(previousBreakdowns[key]);
    if (rev === 0) return null;
    const ratio = b / rev;
    return Number.isFinite(ratio) && ratio !== 0 ? ratio : null;
  }).filter((r) => r != null);
  if (ratios.length === 0) return 0;
  const sum = ratios.reduce((a, b) => a + b, 0);
  const avg = sum / ratios.length;
  return Number.isFinite(avg) ? avg : 0;
}

function revenueMoMPct(revenue, prevRevenue) {
  const prev = safeNum(prevRevenue);
  const curr = safeNum(revenue);
  if (curr === 0) return null;
  if (prev === 0) return null;
  const pct = (curr - prev) / prev;
  return Number.isFinite(pct) ? pct : null;
}

function monthsCoverHeatAlpha(monthCoverStr) {
  const v = parseFloat(String(monthCoverStr), 10);
  if (!Number.isFinite(v) || v >= 3.5) return 0;
  return Math.max(0, Math.min(1, (3.5 - Math.max(0, v)) / 3.5));
}

function monthCoverTooltipParts(monthCover, children) {
  const raw = monthCover == null || monthCover === '' ? '' : String(monthCover);
  const invalid = raw === '' || raw === 'NaN' || raw === 'Infinity';
  const coverStr = invalid ? '0.0' : raw;
  const n = parseFloat(coverStr);
  const safeCover = Number.isFinite(n) ? n : 0;
  const display = children != null && children !== '' ? children : coverStr;
  return { safeCover, display };
}

// const reverseArr = (input) => {
//   var ret = new Array;
//   for(var i = input.length-1; i >= 0; i--) {
//       ret.push(input[i]);
//   }
//   return ret;
// }

// const abstractPost = (sendData, url, history, callback) => {
//   superagent.post(`${backendUrl}/${url}`)
//     .send(sendData)
//     .set('Authorization', `Bearer ${localStorage.getItem("authJWT")}`)
//     .set('accept', 'json')
//     .on('error', (response) => {
//         const code = response.status
//         history.replace(history.location.pathname, {
//             errorStatusCode: code
//         });
//     })
//     .then(response => {
//       const code = response.status
//       if (code > 400) {
//           history.replace(history.location.pathname, {
//             errorStatusCode: code
//           });
//       } else {
//         callback(response.body)
//       }
//     }).catch(err => {
//       console.log(err)
//     });
// }

const MonthCoverToolTip = ({ sku, monthCover, startDate, children }) => {
  const [id, setID] = useState(`SKU-MONTH-${String(sku).split(' ').join('')}${Math.trunc(Math.random() * 1000 + 1)}_${Math.trunc(Math.random() * 1000 + 1)}`);
  useEffect(() => {
    setID(`SKU-${String(sku).split(' ').join('')}${Math.trunc(Math.random() * 1000 + 1)}_${Math.trunc(Math.random() * 1000 + 1)}`);
  }, [sku]);
  const [toolOpen, setToolOpen] = useState(false);
  const toggle = () => setToolOpen((prev) => !prev);

  const { safeCover, display } = monthCoverTooltipParts(monthCover, children);
  const etaDate = moment(startDate).add(1, 'months').add(safeCover * 30, 'days');

  return (
    <TooltipProvider>
      <Tooltip open={toolOpen} onOpenChange={toggle}>
        <TooltipTrigger asChild>
          <span className="cursor-help" id={id}>
            {display}
          </span>
        </TooltipTrigger>
        <TooltipContent>
          <div>ETA OOS: {etaDate.isValid() ? etaDate.format('DD-MM-YYYY') : '—'}</div>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};

const MonthsPage = () => {
  const [r, setR] = useState(false)
  const refresh = () => setR(prev => !prev)

  let [tableData, setTabledata] = useState([])
  let [isLoadingCSVData, setIsLoadingCSVData] = useState(false)
  const [selectedLocation, setSelectedLocation] = useState({ label: 'AU', value: 'AU' })

  const [currentLocationCount, currentLocationCountState] = useQuery({
    url: '/forecast/fetchLocationCount',
    refresh: r,
    queryData: {location: selectedLocation.value}
  })

  const [monthTimeline, monthTimelineState] = useQuery({
    url: '/forecast/getMonthTimeline',
    refresh: r,
    queryData: {location: selectedLocation.value}
  })

  const [pendingData, pendingState] = useQuery({
    url: `/inventory/pendingStock${selectedLocation.value.replace('AU', '')}`,
    refresh: r,
  });

  const [containers, containerState] = useQuery({
    url: `/inventory/fetchUpcomingContainer/`,
    refresh: r,
  });

  const timelinePrevious = monthTimeline?.previousMonths ?? [];
  const timelineFuture = monthTimeline?.futureMonths ?? [];

  const dateArray = monthTimeline?.currentMonth && [
    ...timelinePrevious.map((month) => (
      <th key={String(month.startDate)} colSpan="4">
        {moment(month.startDate).format('MMMM')}
      </th>
    )),
    <th key="current" colSpan="4">
      {moment(monthTimeline.currentMonth.startDate).format('MMMM')}
    </th>,
    ...timelineFuture.map((month) => (
      <th key={String(month.startDate)} colSpan="4">
        {moment(month.startDate).format('MMMM')}
      </th>
    )),
  ];

  const dateArrayData = monthTimeline?.currentMonth && [
    ...timelinePrevious.map((month) => moment(month?.startDate).format('MMMM')),
    moment(monthTimeline.currentMonth?.startDate).format('MMMM'),
    ...timelineFuture.map((month) => moment(month?.startDate).format('MMMM')),
  ];

  const revArray =
    monthTimeline?.currentMonth && [
      ...timelinePrevious.map((month) => safeNum(month?.realRevenue)),
      safeNum(monthTimeline.currentMonth?.estimatedRevenue),
      ...timelineFuture.map((month) => safeNum(month?.estimatedRevenue)),
    ];

  const percentageArray =
    monthTimeline?.currentMonth &&
    revArray.map((revenue, key) => {
      if (key === 0) return null;
      return revenueMoMPct(revenue, revArray[key - 1]);
    });

  useEffect(() => {
    if (!monthTimeline?.currentMonth || !containers || !currentLocationCount || !pendingData) {
      return;
    }
    const allTableData = currentLocationCount.map((line) => {
      const sku = line[0];
      const previousRevs = timelinePrevious.map((month) => safeNum(month?.realRevenue));
      const previousBreakdowns = timelinePrevious.map((month) =>
        safeNum(month?.skuBreakdown?.find((val) => val.sku === sku)?.count),
      );
      const casesPerRev = computeCasesPerRev(previousRevs, previousBreakdowns);

      const start = moment().startOf('month').toDate();
      const end = moment().endOf('month').toDate();
      const today = moment().toDate();
      const dayFrac = end - start === 0 ? 0 : (today - start) / (end - start);
      const p = 1 - Math.round(dayFrac * 100) / 100;

      const currentSalesEstimate = Math.max(
        0,
        Math.ceil(casesPerRev * safeNum(monthTimeline.currentMonth.estimatedRevenue)) || 0,
      );
      const onHandPassDown =
        line
          .filter((val, key) => key !== 0)
          .reduce((partialSum, a) => partialSum + safeNum(a), 0) -
        safeNum(pendingData[sku]) -
        (Math.ceil(currentSalesEstimate * p) || 0);

      const containerLineData = [...containers]
        .reverse()
        .map((container) => {
          const containerLine = container.containerLines.find((cl) => cl.variant.sku === sku);
          const count = containerLine === undefined ? 0 : safeNum(containerLine.quantity);
          const location = container.landingLocation.name;
          const date = container.arrivalDate;
          return { count, location, date };
        })
        .filter((val) => val.count !== 0 && localLocations[selectedLocation.value].includes(val.location));

      const incomingCurrent =
        containerLineData
          .filter(
            (containerLine) =>
              moment(containerLine.date).isBefore(
                moment(monthTimeline.currentMonth.startDate).endOf('month'),
              ) &&
              moment(containerLine.date).isAfter(moment(monthTimeline.currentMonth.startDate).startOf('month')),
          )
          .map((val) => val.count)
          .reduce((partialSum, a) => partialSum + a, 0) || 0;

      const onHand = onHandPassDown + incomingCurrent;
      const currentMonthCover = safeMonthsCoverDisplay(onHand, currentSalesEstimate);

      const futureData = timelineFuture.map((month, monthKey) => {
        const salesEstimate = Math.max(0, Math.ceil(casesPerRev * safeNum(month.estimatedRevenue)) || 0);

        const incomingCount = containerLineData
          .filter(
            (containerLine) =>
              moment(containerLine.date).isBefore(moment(month.startDate).endOf('month')) &&
              moment(containerLine.date).isAfter(moment(month.startDate).startOf('month')),
          )
          .map((val) => val.count)
          .reduce((partialSum, a) => partialSum + a, 0);

        const incomingCountSum = containerLineData
          .filter((containerLine) => moment(containerLine.date).isBefore(moment(month.startDate).endOf('month')))
          .map((val) => val.count)
          .reduce((partialSum, a) => partialSum + a, 0);

        const onHandEstimate = Math.max(
          0,
          onHandPassDown -
            timelineFuture
              .filter((val, key) => key <= monthKey)
              .map((val) => Math.ceil(casesPerRev * safeNum(val.estimatedRevenue)) || 0)
              .reduce((partialSum, a) => partialSum + a, 0) +
            incomingCountSum,
        );
        const monthsCovered = safeMonthsCoverDisplay(onHandEstimate, salesEstimate);

        return {
          sales: salesEstimate,
          onHand: onHandEstimate,
          incoming: incomingCount,
          monthCover: monthsCovered,
          startDate: month.startDate,
        };
      });

      const previousData = previousBreakdowns.map((sales) => ({ sales }));

      return {
        sku: line[0],
        previousMonths: previousData,
        currentMonths: {
          sales: currentSalesEstimate,
          onHand: onHandPassDown,
          incoming: incomingCurrent,
          monthCover: currentMonthCover,
        },
        futureMonths: futureData,
      };
    });
    setTabledata(allTableData);
  }, [containers, currentLocationCount, pendingData, monthTimeline, selectedLocation.value]);

  let usLocations = ['USA - Dallas', 'UNIS']

  const handleCSV = async () => {
    setIsLoadingCSVData(true)
    let addMonthTimelineCSV = null
    let addLocationCountCSV = null

    try {
      const monthTimelineCSV = (await superagent.get(`${backendUrl}${'/forecast/getMonthTimeline'}${'?location='}${selectedLocation.value}&`)
        .set('Authorization', `Bearer ${localStorage.getItem("authJWT")}`)
        .set('accept', 'json')).body
      const locationCountCSV = (await  superagent.get(`${backendUrl}${'/forecast/fetchLocationCount'}${'?location='}${selectedLocation.value}&`)
        .set('Authorization', `Bearer ${localStorage.getItem("authJWT")}`)
        .set('accept', 'json')).body
      addLocationCountCSV = locationCountCSV
      addMonthTimelineCSV = monthTimelineCSV
    } catch (e) {
      console.log(e)
    }

    if (
      !addMonthTimelineCSV?.currentMonth ||
      !addLocationCountCSV?.length ||
      !pendingData ||
      !containers
    ) {
      setIsLoadingCSVData(false);
      return;
    }

    const csvPrevious = addMonthTimelineCSV.previousMonths ?? [];
    const csvFuture = addMonthTimelineCSV.futureMonths ?? [];

    const allTableData = addLocationCountCSV.map((line) => {
      const sku = line[0];
      const previousRevs = csvPrevious.map((month) => safeNum(month?.realRevenue));
      const previousBreakdowns = csvPrevious.map((month) =>
        safeNum(month?.skuBreakdown?.find((val) => val.sku === sku)?.count),
      );
      const casesPerRev = computeCasesPerRev(previousRevs, previousBreakdowns);

      const start = moment().startOf('month').toDate();
      const end = moment().endOf('month').toDate();
      const today = moment().toDate();
      const dayFrac = end - start === 0 ? 0 : (today - start) / (end - start);
      const p = 1 - Math.round(dayFrac * 100) / 100;

      const currentSalesEstimate = Math.max(
        0,
        Math.ceil(casesPerRev * safeNum(addMonthTimelineCSV.currentMonth.estimatedRevenue)) || 0,
      );
      const onHandPassDown =
        line
          .filter((val, key) => key !== 0)
          .reduce((partialSum, a) => partialSum + safeNum(a), 0) -
        safeNum(pendingData[sku]) -
        (Math.ceil(currentSalesEstimate * p) || 0);

      const containerLineData = [...containers]
        .reverse()
        .map((container) => {
          const containerLine = container.containerLines.find((cl) => cl.variant.sku === sku);
          const count = containerLine === undefined ? 0 : safeNum(containerLine.quantity);
          const location = container.landingLocation.name;
          const date = container.arrivalDate;
          return { count, location, date };
        })
        .filter((val) => val.count !== 0 && localLocations[selectedLocation.value].includes(val.location));

      const incomingCurrent =
        containerLineData
          .filter(
            (containerLine) =>
              moment(containerLine.date).isBefore(
                moment(addMonthTimelineCSV.currentMonth.startDate).endOf('month'),
              ) &&
              moment(containerLine.date).isAfter(
                moment(addMonthTimelineCSV.currentMonth.startDate).startOf('month'),
              ),
          )
          .map((val) => val.count)
          .reduce((partialSum, a) => partialSum + a, 0) || 0;

      const onHand = onHandPassDown + incomingCurrent;
      const currentMonthCover = safeMonthsCoverDisplay(onHand, currentSalesEstimate);

      const futureData = csvFuture.map((month, monthKey) => {
        const salesEstimate = Math.max(0, Math.ceil(casesPerRev * safeNum(month.estimatedRevenue)) || 0);

        const incomingCount = containerLineData
          .filter(
            (containerLine) =>
              moment(containerLine.date).isBefore(moment(month.startDate).endOf('month')) &&
              moment(containerLine.date).isAfter(moment(month.startDate).startOf('month')),
          )
          .map((val) => val.count)
          .reduce((partialSum, a) => partialSum + a, 0);

        const incomingCountSum = containerLineData
          .filter((containerLine) => moment(containerLine.date).isBefore(moment(month.startDate).endOf('month')))
          .map((val) => val.count)
          .reduce((partialSum, a) => partialSum + a, 0);

        const onHandEstimate = Math.max(
          0,
          onHandPassDown -
            csvFuture
              .filter((val, key) => key <= monthKey)
              .map((val) => Math.ceil(casesPerRev * safeNum(val.estimatedRevenue)) || 0)
              .reduce((partialSum, a) => partialSum + a, 0) +
            incomingCountSum,
        );
        const monthsCovered = safeMonthsCoverDisplay(onHandEstimate, salesEstimate);

        return {
          sales: salesEstimate,
          onHand: onHandEstimate,
          incoming: incomingCount,
          monthCover: monthsCovered,
          startDate: month.startDate,
        };
      });

      const previousData = previousBreakdowns.map((sales) => ({ sales }));

      return {
        sku: line[0],
        previousMonths: previousData,
        currentMonths: {
          sales: currentSalesEstimate,
          onHand: onHandPassDown,
          incoming: incomingCurrent,
          monthCover: currentMonthCover,
        },
        futureMonths: futureData,
      };
    });

    let dateArrayDataCSV = addMonthTimelineCSV?.currentMonth && [
      ...csvPrevious.map((month) => moment(month?.startDate).format('MMMM')),
      moment(addMonthTimelineCSV.currentMonth?.startDate).format('MMMM'),
      ...csvFuture.map((month) => moment(month?.startDate).format('MMMM')),
    ];
  
    let revArrayCSV = addMonthTimelineCSV?.currentMonth && [
      ...csvPrevious.map((month) => safeNum(month?.realRevenue)),
      safeNum(addMonthTimelineCSV.currentMonth?.estimatedRevenue),
      ...csvFuture.map((month) => safeNum(month?.estimatedRevenue)),
    ];

    let csv_ws1 = [
      ['SKU', dateArrayData?.[0], dateArrayData?.[1], dateArrayData?.[2], dateArrayData?.[3], '', '', '', dateArrayData?.[4], '', '', '', dateArrayData?.[5], '', '', '', dateArrayData?.[6], '', '', '',],
      ['', 'SALES', 'SALES', 'SALES', 'SALES', 'ON HAND', 'INCOMING', 'MONTHS COVER', 'SALES', 'ON HAND', 'INCOMING', 'MONTHS COVER', 'SALES', 'ON HAND', 'INCOMING', 'MONTHS COVER', 'SALES', 'ON HAND', 'INCOMING', 'MONTHS COVER',],
      ['', formatCurrencyUsd(revArray?.[0]), formatCurrencyUsd(revArray?.[1]), formatCurrencyUsd(revArray?.[2]), formatCurrencyUsd(revArray?.[3]), '', '', '', formatCurrencyUsd(revArray?.[4]), '', '', '', formatCurrencyUsd(revArray?.[5]), '', '', '', formatCurrencyUsd(revArray?.[6]), '', '', ''],
      ...tableData.map((item, index) => [
        item.sku,
        ...(item.previousMonths.map(month => [
          month.sales,
        ]).flat()),
        item.currentMonths.sales,
        item.currentMonths.onHand,
        item.currentMonths.incoming,
        item.currentMonths.monthCover,
        ...(item.futureMonths.map(month => [
          month.sales,
          month.onHand,
          month.incoming,
          month.monthCover,
        ]).flat())
      ])
    ];

    let csv_ws2 = [
      ['SKU', dateArrayDataCSV?.[0], dateArrayDataCSV?.[1], dateArrayDataCSV?.[2], dateArrayDataCSV?.[3], '', '', '', dateArrayDataCSV?.[4], '', '', '', dateArrayDataCSV?.[5], '', '', '', dateArrayDataCSV?.[6], '', '', ''],
      ['', 'SALES', 'SALES', 'SALES', 'SALES', 'ON HAND', 'INCOMING', 'MONTHS COVER', 'SALES', 'ON HAND', 'INCOMING', 'MONTHS COVER', 'SALES', 'ON HAND', 'INCOMING', 'MONTHS COVER', 'SALES', 'ON HAND', 'INCOMING', 'MONTHS COVER'], 
      ['', formatCurrencyUsd(revArrayCSV?.[0]), formatCurrencyUsd(revArrayCSV?.[1]), formatCurrencyUsd(revArrayCSV?.[2]), formatCurrencyUsd(revArrayCSV?.[3]), '', '', '', formatCurrencyUsd(revArrayCSV?.[4]), '', '', '', formatCurrencyUsd(revArrayCSV?.[5]), '', '', '', formatCurrencyUsd(revArrayCSV?.[6]), '', '', ''],
      ...allTableData.map((item, index) => [
        item.sku,
        ...(item.previousMonths.map(month => [
          month.sales,
        ]).flat()),
        item.currentMonths.sales,
        item.currentMonths.onHand,
        item.currentMonths.incoming,
        item.currentMonths.monthCover,
        ...(item.futureMonths.map(month => [
          month.sales,
          month.onHand,
          month.incoming,
          month.monthCover,
        ]).flat())
      ])
    ];  

    const ws1 = XLSX.utils.aoa_to_sheet(csv_ws1);
    const ws2 = XLSX.utils.aoa_to_sheet(csv_ws2);
  
    const wb = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(wb, ws1, selectedLocation.value === 'AU' ? 'AU' : 'US');
    XLSX.utils.book_append_sheet(wb, ws2, selectedLocation.value === 'AU' ? 'US' : 'AU');
    const dateString = (new Date()).toDateString().replace(' ', '-').replace(' ', '-').replace(' ', '-')

    XLSX.writeFileXLSX(wb, `FORECAST_${dateString}.csv`)

    setIsLoadingCSVData(false)
  }

  return (
    <div>
      <div className="page-content">
      <div className="w-full px-3 mx-auto xl:max-w-[85%]">
          <Breadcrumbs title="Forecast" breadcrumbItem="Forecast" />
          <Row>
            <Col sm="2" className="sm:w-2/12" style={{paddingBottom: 8}}>
              {isLoadingCSVData ? (
                <div className="spinner-grow text-primary m-1" role="status">
                    <span className="sr-only">Loading...</span>
                </div>
              ) : (
                <Button type="button" variant="secondary" className="btn-lg btn-rounded" onClick={() => {handleCSV();}}>
                  CSV
                </Button>
              )}
            </Col>
          </Row>
          <Row>
            <Col xs="4" className="w-4/12">
              <div className="select2-container mb-4">
                <label className="control-label">Location</label>
                <Select  value={selectedLocation} onChange={setSelectedLocation} placeholder="AU" title="Pickup Location" options={ [{ label: 'AU', value: 'AU' }, { label: 'US', value: 'US' }, { label: 'UK', value: 'UK' }]} />
              </div>
            </Col>
          </Row>
            {
              currentLocationCountState === 'success' &&
              monthTimelineState === 'success' &&
              monthTimeline?.currentMonth &&
              revArray &&
              dateArray ? (
                <table className="table mb-0">
                  <thead style={{position: 'sticky', top: 123, background: 'white'}}>
                    <tr>
                      <th>SKU</th>
                      { dateArray }
                    </tr>
                    <tr>
                      <td></td>
                      {
                        revArray.map((rev, key) => (
                          <td
                            key={`rev-head-${key}`}
                            colSpan="4"
                            style={{ whiteSpace: 'nowrap', verticalAlign: 'middle' }}
                          >
                            <span
                              style={{
                                display: 'inline-flex',
                                alignItems: 'center',
                                flexWrap: 'nowrap',
                                gap: '6px',
                              }}
                            >
                              {formatCurrencyUsd(rev)}
                              {percentageArray[key] != null && (
                                <span
                                  className={`text-${percentageArray[key] > 0 ? 'success' : 'danger'}`}
                                  style={{ whiteSpace: 'nowrap' }}
                                >
                                  <i
                                    className={`bx bx-caret-${percentageArray[key] > 0 ? 'up' : 'down'} mr-0.5`}
                                  />
                                  {(percentageArray[key] * 100).toFixed(2)}%
                                </span>
                              )}
                            </span>
                          </td>
                        ))
                      }
                    </tr>
                    <tr>
                      <td></td>
                      {
                        revArray.map((rev, key) => (key >= timelinePrevious.length) ? (
                          <Fragment key={`sub-${key}`}>
                          <td> SALES </td>
                          <td> ON HAND </td>
                          <td> INCOMING </td>
                          <td> MONTHS COVER </td>
                          </Fragment>
                        ): (
                          <Fragment key={`sub-${key}`}>
                          <td colSpan="4">SALES</td>
                          </Fragment>
                        ))
                      }
                    </tr>
                  </thead>
                  <tbody>
                  {
                   tableData.map((item) => {
                      if (item.previousMonths.every(number => number.sales === 0)) {
                        return null
                      }
                      return (
                        <tr key={item.sku}>
                          <td>{item.sku}</td>
                          {
                            item.previousMonths.map((val, idx) => (
                              <Fragment key={`${item.sku}-p-${idx}`}>
                                <td colSpan="4">{val.sales}</td>
                              </Fragment>
                            ))
                          }
                          <td>{item.currentMonths.sales}</td>
                          <td>{item.currentMonths.onHand}</td>
                          <td>{item.currentMonths.incoming}</td>
                          <td style={{background: `rgba(200, 0, 0, ${monthsCoverHeatAlpha(item.currentMonths.monthCover)})`}}>
                            <MonthCoverToolTip sku={item.sku} monthCover={item.currentMonths.monthCover} startDate={monthTimeline.currentMonth.startDate}>
                              {item.currentMonths.monthCover}
                            </MonthCoverToolTip>
                          </td>
                          {
                            item.futureMonths.map((month, fidx) => (
                              <Fragment key={`${item.sku}-f-${fidx}`}>
                                  <td>{month.sales}</td>
                                  <td>{month.onHand}</td>
                                  <td>{month.incoming}</td>
                                  <td style={{background: `rgba(200, 0, 0, ${monthsCoverHeatAlpha(month.monthCover)})`}}>
                                    <MonthCoverToolTip sku={item.sku} monthCover={month.monthCover} startDate={month.startDate}>
                                      {month.monthCover}
                                    </MonthCoverToolTip>
                                  </td>
                              </Fragment>
                            ))
                          }
                        </tr>
                      )
                    })
                  }
                  </tbody>
              </table>
              ) : (
                <div style={{ width: '100%', height: '100%', display: 'flex', justifyContent: 'center', padding: 48 }}>
                  <div className="spinner-grow text-primary m-1" role="status">
                    <span className="sr-only">Loading...</span>
                  </div>
                </div>
              )
            }
        </div>
      </div>
    </div>
  )
}


export default MonthsPage
